export default __webpack_public_path__ + "static/media/router.e5927acd.svg";